import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Loader2, Trash2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { useAuth } from '../../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/sepa-stripe/admin/essais`;

/** Super admin : supprime d'un clic les mandats et membres marqués [TEST] (documents GED, reçus et fichiers compris). */
export const NettoyageEssais = ({ onDone }) => {
  const { user, getAuthHeader } = useAuth();
  const [liste, setListe] = useState(null);
  const [encours, setEncours] = useState(false);
  if (!['super_admin', 'superadmin'].includes((user?.role || '').toLowerCase())) return null;

  const ouvrir = async () => {
    try { setListe((await axios.get(API, { headers: getAuthHeader() })).data); } catch (e) { toast.error(e.response?.data?.detail || 'Liste indisponible'); }
  };
  const supprimer = async () => {
    setEncours(true);
    try {
      const { data } = await axios.delete(API, { headers: getAuthHeader() });
      const s = data.supprime;
      toast.success(`Essais supprimés : ${s.mandats} mandat(s), ${s.membres} membre(s), ${s.documents_ged} document(s) GED`);
      setListe(null);
      onDone?.();
    } catch (e) { toast.error(e.response?.data?.detail || 'Nettoyage impossible'); } finally { setEncours(false); }
  };
  const vide = liste && !liste.mandats.length && !liste.membres.length;
  return (
    <>
      <button type="button" onClick={ouvrir} className="inline-flex items-center gap-1.5 rounded-lg border border-white/30 px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-white/10" data-testid="nettoyage-essais-btn">
        <Trash2 className="h-3.5 w-3.5" /> Nettoyer les essais [TEST]
      </button>
      <Dialog open={!!liste} onOpenChange={(o) => !o && setListe(null)}>
        <DialogContent className="max-w-xl" data-testid="nettoyage-essais-dialog">
          <DialogHeader><DialogTitle>Nettoyer les essais marqués [TEST]</DialogTitle></DialogHeader>
          {vide ? <p className="text-sm text-slate-500">Aucun essai marqué [TEST].</p> : liste && (
            <div className="space-y-3 text-sm">
              <div>
                <p className="font-semibold text-[#0a3d62]">{liste.mandats.length} mandat(s) SEPA</p>
                <ul className="ml-4 list-disc text-xs text-slate-600">{liste.mandats.map((m) => <li key={m.id}>{m.rum} — {m.membre_nom} ({m.raison_sociale || m.email})</li>)}</ul>
              </div>
              <div>
                <p className="font-semibold text-[#0a3d62]">{liste.membres.length} membre(s)</p>
                <ul className="ml-4 list-disc text-xs text-slate-600">{liste.membres.map((m) => <li key={m.id}>{m.numero_membre} — {m.raison_sociale || `${m.prenom || ''} ${m.nom || ''}`} ({m.email})</li>)}</ul>
              </div>
              <p className="rounded-lg bg-rose-50 p-2 text-xs text-rose-800">Seront aussi supprimés définitivement : {liste.nb_documents_ged} document(s) GED et reçus (fichiers compris), {liste.nb_souscriptions} souscription(s) et les comptes d&apos;accès de ces membres.</p>
              <button type="button" disabled={encours} onClick={supprimer} className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-rose-600 px-4 py-2 font-semibold text-white hover:bg-rose-700 disabled:opacity-60" data-testid="nettoyage-essais-confirmer">
                {encours ? <Loader2 className="h-4 w-4 animate-spin" /> : <Trash2 className="h-4 w-4" />} Supprimer définitivement
              </button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
